// extracted by mini-css-extract-plugin
export default {"reset":"resetPassword_reset__Awo7x"};